import React, { useState } from 'react';
import { Reset2faToken, Reset2faTokenSuccess } from './';
import { SetLoginForm } from '@app/models';

interface IProps {
    contextToken: string;
    setLoginForm?: SetLoginForm;
}

export const Reset2faTokenChooseComponent: React.SFC<IProps> = ({ contextToken, setLoginForm }) => {
    const [isResetToken, setIsResetToken] = useState<boolean>(false);

    if (isResetToken) {
        return <Reset2faTokenSuccess setLoginForm={setLoginForm} />;
    } else {
        return <Reset2faToken contextToken={contextToken} setIsResetToken={setIsResetToken} />;
    }
};
